import { Link, NavLink } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { company, navLinks } from "@/content/siteContent";
const Brand = () => (
  <>
    <img src="/images/logo-mark.png" alt="" className="brand-mark" />
    <img src="/images/logo-text.png" alt={company.name} className="brand-wordmark" />
  </>
);

const TopBar = () => (
  <div className="topbar" data-testid="topbar">
    <div className="container topbar-inner">
      <span className="topbar-item topbar-hide-sm" data-testid="topbar-location">
        <MapPin size={14} /> {company.location}
      </span>
      <div className="topbar-group">
        <a className="topbar-item" href={company.phoneLink ? `tel:${company.phoneLink}` : "/contact"} data-testid="topbar-phone">
          <Phone size={14} /> {company.phone}
        </a>
        <a className="topbar-item" href={`mailto:${company.email}`} data-testid="topbar-email">
          <Mail size={14} /> {company.email}
        </a>
      </div>
    </div>
  </div>
);

export const Header = () => (
    <>
    <TopBar />
    <header className="site-header" data-testid="site-header">
      <div className="container header-inner">
        <Link to="/" className="brand" data-testid="header-brand-link">
          <Brand />
        </Link>
        <nav className="nav-desktop" data-testid="nav-desktop">
          {navLinks.map((l) => (
            <NavLink key={l.id} to={l.path} end data-testid={`nav-${l.id}-link`}>
              {l.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <nav className="nav-mobile" data-testid="nav-mobile">
        {navLinks.map((l) => (
          <NavLink key={l.id} to={l.path} end data-testid={`nav-mobile-${l.id}-link`}>
            {l.label}
          </NavLink>
        ))}
      </nav>
    </header>
    </>
);
